module.exports = __webpack_public_path__ + "static/sheep-8714926f5253b5e63a09091aada79c79.jpg";